import styled from 'styled-components';
import { Box } from '../Core';

export const BenchmarkWrapper = styled(Box)`
  border-radius: ${({ theme }) => theme.borderRadiusDefault}px;
  padding: ${({ theme }) => `${theme.spacing2}px ${theme.spacing4}px`};
`;
